<template>
    <a href="javascript:void(0);" @click="downloadPDF" class="download-workpacket-pdf">
        <span class="btn__icon">
            <img src="@/assets/images/download.png" alt="Download" />
        </span>
        <span class="btn__text">{{ buttonLabel }}</span>
    </a>
    <div ref="pdfSource" id="work-packet" style="display: none;">
        <section class="work__packet__pdf__page">
            <div class="sideimg__block">
                <img src="@/assets/images/pdf/sidebar-img.png" style="width:100%;height:1120px;" />
            </div>
            <div class="content__block__wrapper">
                <div class="logo__wrap">
                    <img src="@/assets/images/pdf/eesa-pdf-logo.png" style="max-width: 100%;" />
                </div>
                <h1 class="main__title">Work Packet</h1>
                <h4 class="sub__title">{{ learnerName }}</h4>
                <div class="text__wrapper">
                    <p>This packet is designed to support learners in developing their early echoic skills, which
                        are essential for language acquisition and verbal behavior. Through a structured and
                        systematic approach, the EESA Program Planner and Protocol aim to assess, enhance, and track
                        the progress of these skills, providing a solid foundation for further language development.
                    </p>
                </div>
            </div>
        </section>

        <section class="information__pdf__page">
            <div class="cover__wrapper">
                <div class="page__head__block">
                    <p class="head__title">Information</p>
                    <p class="para">Welcome to the EESAPP Work Packet</p>
                </div>
                <div class="main__body__wrapper">
                    <div class="img__wrapper">
                        <img src="@/assets/images/new-roup.jpg" />
                    </div>
                    <div class="content__block__wrap">
                        <h3 class="title">Early Echoic Skills Assessment (EESA)</h3>
                        <div class="description__wrapper">
                            <p>This packet is designed to support learners in developing their early echoic skills,
                                which are essential for language acquisition and verbal behavior.</p>
                            <p>Through a structured and systematic approach, the EESA Program Planner and Protocol
                                aim to assess, enhance, and track the progress of these skills, providing a solid
                                foundation for further language development.</p>
                            <p>Orbi sit cursus tincidunt massa et a. Dolor odio parturient cursus justo nunc enim,
                                a, sit facilisi. Eleifend at ac lacus, ullamcorper mauris eget tortor mollis.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="result__summary__pdf__page">
            <div class="cover__wrapper">
                <div class="page__head__block">
                    <h4 class="head__title">Result Summary</h4>
                    <p class="para">Enter EESAPP Scores Below</p>
                    <p class="para">{{ EESA_SCOPE_NOTE }}</p>
                </div>
                <div class="result__group__wrapper">
                    <div class="group__row__block mt20">
                        <template v-for="(group, key) in groupScores" :key="key">
                            <div class="group__block__item group-row" :class="`color${key}`">
                                <div class="group__text__wrapper">
                                    <label>Group {{ key }}</label>
                                    <span>{{ group.score }}/{{ group.total }}</span>
                                </div>
                                <div class="result__round__box">
                                    <span>{{ group.percentage }}%</span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="cover__wrapper">
                <div class="page__head__block">
                    <h4 class="head__title">Average SCV</h4>
                </div>
                <div class="voice__bank__wrapper">
                    <div class="voice__bank__list__block">
                        <template v-for="(scv, key) in scvAverages" :key="key">
                            <div class="voice__bank__item" :class="`color${key}`">
                                <h6 class="title">Group {{ key }}</h6>
                                <div class="sepline"></div>
                                <div class="value__group__wrap">
                                    <p v-if="skip_group && (key == 1 || key == 2)">You have skipped this section. Normal
                                        Score is 01 02 03</p>
                                    <template v-else>
                                        <div class="value__box">
                                            <label>Syll</label>
                                            <span>{{ scv.syllable }}</span>
                                        </div>
                                        <div class="value__box">
                                            <label>C</label>
                                            <span>{{ scv.consonant }}</span>
                                        </div>
                                        <div class="value__box">
                                            <label>V</label>
                                            <span>{{ scv.vowel }}</span>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>

        <template v-for="group in [1, 2, 3]" :key="group">
            <section class="analysis__group__pdf__page" style=" max-height: fit-content;">
                <div class="page__head__block">
                    <p class="head__title">Analysis</p>
                    <p class="para">Group {{ group }}</p>
                </div>
                <div class="pb__20px">
                    <div class="analysis__info__block">
                        <div class="info__table__block">
                            <div class="title__group">
                                <label>Directions</label>
                                <label>Info Source</label>
                            </div>
                            <div class="spacing">
                                <div class="sepline__divider"></div>
                            </div>
                            <div class="info__block__wrapper">
                                <div class="info__text__wrap text-a">
                                    <p>In Column A, each test item that scored 1 point is highlighted.</p>
                                </div>
                                <div class="info__text__wrap text-b">
                                    <p>Items shown in grey were removed while selecting the items of Group {{ group }}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table__data__block" :class="`group-${group}`"
                    v-if="workpacket[`group${group}`]?.groupQuestions?.length">
                    <div v-for="(questionSet, pageIndex) in paginatedGroupQuestions(group)" :key="pageIndex"
                        class="table__data__page"
                        :style="`${pageIndex > 0 ? 'page-break-before: always;height: 1120px; padding-top: 20px;' : 'height: 704px;'}`">
                        <div class="analysis__table__data__block">
                            <div class="spacing__cover__right">
                                <div class="table__head__block">
                                    <div class="head__item tal">
                                        <label>Column A</label>
                                        <span>Test Item</span>
                                    </div>
                                    <div class="head__item tac">
                                        <label>Column B</label>
                                        <div class="group__numbers">
                                            <span>Syll</span>
                                            <span>C</span>
                                            <span>V</span>
                                        </div>
                                    </div>
                                    <div class="head__item tar">
                                        <label>Column C</label>
                                        <span>SC Code</span>
                                    </div>
                                </div>

                                <div class="spacing">
                                    <div class="sepline__divider"></div>
                                </div>
                                <div class="table__data__list__wrapper">
                                    <template v-for="question in questionSet" :key="question.id">
                                        <div class="table__data__row" :class="{
                                            purple__row: Number(question?.attempts?.[0]?.score) === 1,
                                            gray__row: Number(question?.attempts?.[0]?.score) != 1 && !question?.removed,
                                            red__row: question?.removed
                                        }">
                                            <div class="data__item tal">
                                                <label>{{ question.question }}</label>
                                                <span class="phonetic-symbols">{{ formatConsonants(question.consonant)
                                                    }}</span>
                                            </div>
                                            <div class="data__item combine__value tac">
                                                <span>{{ question.scv?.charAt(0) ?? '' }}</span>
                                                <span>{{ question.scv?.charAt(1) ?? '' }}</span>
                                                <span>{{ question.scv?.charAt(2) ?? '' }}</span>
                                            </div>
                                            <div class="data__item tar">
                                                <span v-html="formatSuperscript(question.sccode)"></span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table__data__block" v-else
                    :style="`${pageIndex > 0 ? 'page-break-before: always;height: 1120px; padding-top: 20px;' : 'height: 850px;'}`">
                    <div class="analysis__info__block"
                        style=" padding: 50px; display: flex; justify-content: center; align-items: center; ">
                        <p v-if="skip_group && (group == 1 || group == 2)" style="font-size: 18px; text-align: center;">
                            You have skipped
                            this section. Normal Score is 01 02 03</p>
                        <p style="font-size: 18px; text-align: center;" v-else>No selected items.</p>
                    </div>
                </div>
            </section>
        </template>

        <template v-for="group in [1, 2, 3]" :key="group">
            <section class="analysis__group__pdf__page">
                <div class="page__header__block">
                    <h4 class="head__title">Target Guide</h4>
                    <p class="para">Group {{ group }}</p>
                </div>
                <div class="pb__20px">
                    <div class="analysis__info__block">
                        <div class="info__table__block">
                            <div class="title__group">
                                <label>Directions</label>
                                <label>Info Source</label>
                            </div>
                            <div class="spacing">
                                <div class="sepline__divider"></div>
                            </div>
                            <div class="info__block__wrapper">
                                <div class="info__text__wrap left">
                                    <p>Performance range based on items scored 1 is highlighted.</p>
                                </div>
                                <div class="info__text__wrap right">
                                    <p>Group {{ group }} SC Analysis</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pb__20px">
                    <div class="target__data__cover">
                        <div class="target__head__title">
                            <div class="head__label">
                                <label>How Many Items Scored 1 Point?</label>
                            </div>
                            <div class="head__label">
                                <label>frequent number for 1-Point items</label>
                            </div>
                            <div class="head__label">
                                <label>General Tips</label>
                            </div>
                        </div>
                        <template v-for="(range, r_i) in scoreRanges" :key="range.label">
                            <div class="target__value__row"
                                :class="{ 'active__target__group': range.condition(groupScores?.[group]?.score_one) == true, 'mb12': r_i != 2 }">
                                <div class="data__value__text">
                                    <label>{{ range.label }}</label>
                                    <span>{{ range.range }} - {{ range.condition(groupScores?.[group]?.score_one)
                                        }}</span>
                                </div>
                                <div class="data__value__text combine__value">
                                    <div class="point__text" v-for="key in ['syllable', 'consonant', 'vowel']"
                                        :key="key">
                                        <label>{{ key === 'syllable' ? 'Syll' : key.charAt(0).toUpperCase()
                                            }}</label>
                                        <span>{{ range.condition(groupScores?.[group]?.score_one) ?
                                            scvAverages?.[group]?.[key] : '-' }}</span>
                                    </div>
                                </div>
                                <div class="data__value__text general__tips__box">
                                    <p>{{ range.tip }}</p>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="target__analysis__info__block">
                    <div class="pb__10px">
                        <div class="info__block__wrapper">
                            <h4 class="title">Error analysis - which skills are a priority?</h4>
                            <div class="text__wrapper">
                                <p>How many items scored 0 points? info from Group 2 test page</p>
                                <p>In Group 2, a score of “0” indicates inaccurate vowel(s) OR all consonants were
                                    omitted.
                                    This
                                    means syllable complexity should straddle Group 1 - Group 2 skills if there are a
                                    lot of
                                    “0”
                                    scores.</p>
                            </div>
                        </div>
                    </div>
                    <div class="target__analysis__data__list">
                        <template v-for="(range, index) in errorAnalysisTips" :key="range.points">
                            <div class="pb__10px">
                                <div class="target__data__item"
                                    :class="{ 'active__target__group': range.condition(groupScores?.[group]?.score_zero) == true }">
                                    <div class="value__text__block">
                                        <label>{{ range.points }}</label>
                                        <span v-if="index === 0" class="text">High error</span>
                                    </div>
                                    <div class="data__info__block">
                                        <p>{{ range.tip }}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </section>
        </template>

        <section class="starting__targets__pdf__page">
            <div class="page__head__block">
                <p class="head__title">Starting Targets Decision Box</p>
                <p class="para">Using Task 1 information, Check all boxes below that apply.</p>
                <p class="para">{{ EESA_SCOPE_NOTE }}</p>
            </div>
            <div class="table__data__block">
                <div class="table__head__block">
                    <span class="tar">If Group score is below 80%</span>
                    <span class="tac">If Group score is at or above 80%</span>
                </div>
                <div class="spacing">
                    <div class="sepline__divider"></div>
                </div>
                <div class="table__data__list__block">
                    <template v-for="i in 5" :key="i">
                        <div class="check__group__box pb__10px" :class="{
                            'active__check__group': groupTargetActivation[i],
                        }">
                            <div class="table__data__row__block text-label" style="display:flex;align-items:center;">
                                <span class="row__label">Group {{ i }}</span>
                                <template v-for="(checkbox, idx) in checkboxConfig[i]" :key="idx">
                                    <div class="checkbox__group">
                                        <img src="@/assets/images/checkbox-white.png" width="20"
                                            v-if="checkbox.condition && groupTargetActivation[i]" />
                                        <img src="@/assets/images/pdf/checkbox-icon.png" width="20"
                                            v-else-if="checkbox.condition && !groupTargetActivation[i]" />
                                        <img src="@/assets/images/pdf/checkbox-icon.png" width="20" v-else />
                                        <label v-html="checkbox.label"></label>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <!-- No echoic targets indicated: the Guide's alternative, quoted -->
            <div class="table__data__block no__targets__block" v-if="noTargets">
                <p class="head__title">{{ NO_TARGETS_HEADING }}</p>
                <p class="para">{{ NO_TARGETS_INTRO }}</p>
                <p class="para page__ref">{{ NO_TARGETS_INTRO_REF }}</p>
                <p class="para">{{ NO_TARGETS_ACTIVITIES_LEAD }}</p>
                <ul class="no__targets__list">
                    <li v-for="(activity, index) in NO_TARGETS_ACTIVITIES" :key="index">
                        <strong>{{ activity.label }}</strong>
                        <span v-if="activity.detail"> &mdash; {{ activity.detail }}</span>
                    </li>
                </ul>
                <p class="para">{{ NO_TARGETS_CLOSING }}</p>
                <p class="para page__ref">{{ NO_TARGETS_ACTIVITIES_REF }}</p>
            </div>
        </section>

        <section class="starting__targets__pdf__page">
            <div class="page__header__block" style="display: flex; align-items: center;">
                <div class="page__head__block" style="padding-left: 0;">
                    <p class="head__title">Starting Targets - Syllable Complexity</p>
                    <p class="para">Based on the information form</p>
                </div>
                <div class="heading__label__block tar">
                    <span style="margin-top: -25px;">Worksheet A</span>
                </div>
            </div>
            <template v-for="group in 3" :key="group">
                <div class="pb__10px">
                    <div class="group__block__wrapper" :class="{ purple__block: groupTargetActivation[group] }">
                        <h4 class="title">Group {{ group }}</h4>
                        <div class="spacing">
                            <div class="sepline__divider"></div>
                        </div>
                        <div class="different__data__blocks">
                            <div class="group__item__block">
                                <span class="label__title">Different V Sounds</span>
                                <div class="number__group__wrap">
                                    <div class="number">
                                        <p>{{ scvAverages?.[group]?.vowel }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="group__item__block">
                                <span class="label__title">Different C Sounds</span>
                                <div class="number__group__wrap">
                                    <div class="number">
                                        <p>{{ scvAverages?.[group]?.consonant }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="group__item__block">
                                <span class="label__title">Syllables</span>
                                <div class="number__group__wrap">
                                    <div class="number">
                                        <p>{{ scvAverages?.[group]?.syllable }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </section>

        <section class="starting__targets__pdf__page">
            <div class="page__header__block" style="display: flex; align-items: center;">
                <div class="page__head__block" style="padding-left: 0;">
                    <p class="head__title">Starting Targets - Length of Syllable Combinations</p>
                    <p class="para">Based on the information form</p>
                </div>
                <div class="heading__label__block tar">
                    <span style="margin-top: -25px;">Worksheet B</span>
                </div>
            </div>
            <div class="pb__10px">
                <div class="starting__targets__group__block"
                    :class="{ 'purple__block': (groupTargetActivation[4] || groupTargetActivation[5]) }">
                    <h4 class="title">Group 4-5</h4>
                    <div class="spacing">
                        <div class="sepline__divider"></div>
                    </div>
                    <div class="data__content__block">
                        <span class="title">Syllable Range Combo</span>
                        <div class="numbers__box">
                            <div>
                                <p>{{ getRange }}</p>
                            </div>
                        </div>
                        <span class="title">Advance To</span>
                        <div class="advance__group__block">

                            <div class="number__group__block">
                                <div :style="getRange === '3 - 4' ? { backgroundColor: 'white', color: 'black' } : {}">
                                    <p>3 - 4</p>
                                </div>
                                <div :style="getRange === '4 - 5' ? { backgroundColor: 'white', color: 'black' } : {}">
                                    <p>4 - 5</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="">
                <div class="starting__targets__example__wrapper">
                    <h6 class="title">Examples</h6>
                    <div class="example__table__block">
                        <div class="table__head__block">
                            <span class="head__item">Syllable Combo Range</span>
                            <span class="head__item">Lower Range Example</span>
                            <span class="head__item">Upper Range Example</span>
                        </div>
                        <div class="spacing">
                            <div class="sepline__divider"></div>
                        </div>
                        <div class="example__row__list__wrapper">
                            <div class="pb__20px">
                                <div class="row__item__block">
                                    <div>2 - 3</div>
                                    <div>Puppy</div>
                                    <div>One Puppy</div>
                                </div>
                            </div>
                            <div class="pb__20px">
                                <div class="row__item__block purple__row">
                                    <div>3 - 4</div>
                                    <div>Taco Time</div>
                                    <div>it’s Taco Time</div>
                                </div>
                            </div>
                            <div class="pb__20px">
                                <div class="row__item__block">
                                    <div>4 - 5</div>
                                    <div>Peanut Butter</div>
                                    <div>Some Peanut Butter</div>
                                </div>
                            </div>

                            <div class="pb__20px">
                                <div class="row__item__block">
                                    <div>5 - 6</div>
                                    <div>Jump Over The Rocks</div>
                                    <div>Eve Jumped Over The Rocks</div>
                                </div>
                            </div>

                            <div class="pb__20px">
                                <div class="row__item__block">
                                    <div>6 - 7</div>
                                    <div>Let’s Go To Grandma’s House</div>
                                    <div>Let’s Not Go To Grandma’s House</div>
                                </div>
                            </div>
                            <div>
                                <div class="row__item__block">
                                    <div>7 - 8</div>
                                    <div>I Count 7 Bananas</div>
                                    <div>I Count 17 Bananas</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="mini__program__plan">
            <div class="page__head__block">
                <p class="head__title">Preferences List</p>
            </div>
            <div class="pb__10px">
                <div class="faq__info__block__wrapper">
                    <div class="pb__20px">
                        <div class="faq__block__item">
                            <p>The preferences list can inform potential speech targets as vocal - verbal mands</p>
                            <p>Info sources: Preference tests, informal observations of high - preference items.</p>
                        </div>
                    </div>
                    <div class="faq__block__item">
                        <p><strong>Directions</strong></p>
                        <ul>
                            <li>
                                <p>List potential reinforcers in the boxes below.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="pb__10px">
                <div class="option__block__wrapper">
                    <div class="option__block__item">
                        <h4 class="title">Activities (Optional)</h4>
                        <div class="ans">
                            <p>{{ jsonDecodeNote(assessment?.note?.preferences_list)?.activities ?
                                jsonDecodeNote(assessment?.note?.preferences_list)?.activities : 'No' }}</p>
                        </div>
                    </div>
                    <div class="option__block__item">
                        <h4 class="title">Items (Optional)</h4>
                        <div class="ans">
                            <p>{{ jsonDecodeNote(assessment?.note?.preferences_list)?.items ?
                                jsonDecodeNote(assessment?.note?.preferences_list)?.items : 'No' }}</p>
                        </div>
                    </div>
                    <div class="option__block__item">
                        <h4 class="title">People, Places (Optional)</h4>
                        <div class="ans">
                            <p>{{ jsonDecodeNote(assessment?.note?.preferences_list)?.places ?
                                jsonDecodeNote(assessment?.note?.preferences_list)?.places : 'No' }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="note__block__wrapper">
                <div class="inner__note__block">
                    <div class="head__group__wrap">
                        <span class="title">Note:</span>
                    </div>
                    <div class="text__block__wrapper">
                        <p>This list of reinforcers promotes training vocal - verbal targets as mands or mand - tact's.
                        </p>
                        <p>This list should be expanded to include words or phrases that are important to learn, but
                            that
                            may not have particular reinforcing value at first. Example: items used daily (fork, shop,
                            shoes).</p>
                    </div>
                </div>
            </div>
        </section>

         <template v-if="assessment?.note?.mini_program_plan">
            <section class="mini__program__plan" v-for="(targets, pageIndex) in paginatedMiniProgramPlan(assessment?.note?.mini_program_plan)" :key="pageIndex">
                <div class="page__head__block">
                    <p class="head__title">Mini - Program Plan</p>
                </div>
                <div class="info__wrapper" v-if="pageIndex === 0">
                    <p><strong>Also, see EESA Guide, Chapter 1.</strong></p>
                    <p>In grid below, brainstorm some appropriate starting targets. Use task 2 info to hep.</p>
                </div>
                <div class="pb__10px" v-if="pageIndex === 0">
                    <div class="faq__info__block__wrapper">
                        <div class="pb__20px">
                            <div class="faq__block__item">
                                <p><strong>How do echoic skills foster other language skills?</strong></p>
                                <p>These targets could serve as echoic prompts to strengthen the same vocal response in
                                    other
                                    vocal- verbal contexts such as mand, tact, or intraverbal.</p>
                            </div>
                        </div>
                        <div class="faq__block__item">
                            <p><strong>Prompts will need to be faded during training, but initially these prompts should be
                                    effective in evoking an echoic response.Why?</strong></p>
                            <p>Because the targets are based on skills already demonstrated by the learner on EESAPP test
                                items.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="pb__10px">
                    <div class="syllable__range__block__wrapper">
                        <template v-if="pageIndex === 0">
                            <span class="title">Syllable Range</span>
                            <div class="label__tag__block">
                                <div class="number__tag">
                                    <p style=" margin-top: -10px; padding: 10px 5px; ">{{ getRange }}</p>
                                </div>
                            </div>
                            <div class="data__value__wrapper">
                                <div class="inline__box">
                                    <div class="data__tag__wrap">
                                        <span class="data__text">Max Syllables</span>
                                        <span class="number__text">{{ getMaxSCVAverages?.syllable }}</span>
                                    </div>
                                </div>
                                <div class="inline__box">
                                    <div class="data__tag__wrap">
                                        <span class="data__text">Max CS</span>
                                        <span class="number__text">{{ getMaxSCVAverages?.consonant }}</span>
                                    </div>
                                </div>
                                <div class="inline__box">
                                    <div class="data__tag__wrap">
                                        <span class="data__text">Max VS</span>
                                        <span class="number__text">{{ getMaxSCVAverages?.vowel }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="text__block__wrapper">
                            <h6 class="label__title">Ideas for Verbal Targets:</h6>
                            
                            <template v-if="assessment?.note?.mini_program_plan">
                                <div class="ai-data-list" style="margin-top: 10px;">
                                    <div class="ai-data-item" v-for="(target, tIndex) in targets" :key="`${tIndex}`" style="padding: 5px 15px 15px;">
                                        <div class="ai-data-item-head">
                                            <p class="rlms-fw-500 rlms-fs-xs">{{ pageIndex === 0 ? tIndex + 1 : 4 + (pageIndex - 1) * 10 + tIndex + 1 }}. {{ target.word }}</p>
                                        </div>
                                        <ul class="ai-data-item-body">
                                            <li><p>Phonetic:</p><span>{{ target.ipa }}</span></li>
                                            <li><p>Consonants:</p><span>{{ target.consonants }}</span></li>
                                            <li><p>Vowels: </p><span>{{ target.vowels }}</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <template v-else>
            <section class="mini__program__plan">
                <div class="page__head__block">
                    <p class="head__title">Mini - Program Plan</p>
                </div>
                <div class="info__wrapper">
                    <p><strong>Also, see EESA Guide, Chapter 1.</strong></p>
                    <p>In grid below, brainstorm some appropriate starting targets. Use task 2 info to hep.</p>
                </div>
                <div class="pb__10px">
                    <div class="faq__info__block__wrapper">
                        <div class="pb__20px">
                            <div class="faq__block__item">
                                <p><strong>How do echoic skills foster other language skills?</strong></p>
                                <p>These targets could serve as echoic prompts to strengthen the same vocal response in
                                    other
                                    vocal- verbal contexts such as mand, tact, or intraverbal.</p>
                            </div>
                        </div>
                        <div class="faq__block__item">
                            <p><strong>Prompts will need to be faded during training, but initially these prompts should be
                                    effective in evoking an echoic response.Why?</strong></p>
                            <p>Because the targets are based on skills already demonstrated by the learner on EESAPP test
                                items.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="pb__10px">
                    <div class="syllable__range__block__wrapper">
                        <template>
                            <span class="title">Syllable Range</span>
                            <div class="label__tag__block">
                                <div class="number__tag">
                                    <p style=" margin-top: -10px; padding: 10px 5px; ">{{ getRange }}</p>
                                </div>
                            </div>
                            <div class="data__value__wrapper">
                                <div class="inline__box">
                                    <div class="data__tag__wrap">
                                        <span class="data__text">Max Syllables</span>
                                        <span class="number__text">{{ getMaxSCVAverages?.syllable }}</span>
                                    </div>
                                </div>
                                <div class="inline__box">
                                    <div class="data__tag__wrap">
                                        <span class="data__text">Max CS</span>
                                        <span class="number__text">{{ getMaxSCVAverages?.consonant }}</span>
                                    </div>
                                </div>
                                <div class="inline__box">
                                    <div class="data__tag__wrap">
                                        <span class="data__text">Max VS</span>
                                        <span class="number__text">{{ getMaxSCVAverages?.vowel }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="text__block__wrapper">
                            <h6 class="label__title">Ideas for Verbal Targets: N/A</h6>
                        </div>
                    </div>
                </div>
            </section>
        </template>

        <section class="mini__program__plan" v-if="workpacketData">
            <div class="page__head__block">
                <p class="head__title">Syllable Tracker</p>
            </div>
            <div class="pb__10px">
                <div class="faq__info__block__wrapper">
                    <div class="pb__20px">
                        <div class="faq__block__item">
                            <div style="margin-top: -15px;">
                                <p>Purpose: The Syllable Tracker helps identify syllables that are “available” as speech
                                    targets.</p>
                                <p>Info sources: EESAPP test items, informal observations of vocalizations.</p>
                            </div>
                        </div>
                    </div>
                    <div class="faq__block__item">
                        <div style="margin-top: -15px;">
                            <p><strong>Directions</strong></p>
                            <ul>
                                <li>
                                    <p>Put an x in the boxes of all syllables the learner can say.</p>
                                    <ul>
                                        <li>
                                            <p>Find interactions of vowels (V) and consonants (C).</p>
                                        </li>
                                        <li>
                                            <p>Mark X in shaded top row if syllable is a single vowel only.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>Syllable Tracker information will be used in TASK 5.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pb__10px">
                <div class="indicator__block__wrap">
                    <div class="indicator__option">
                        <img src="@/assets/images/pdf/purple-checkbox-img.png" /> <span>Automated</span>
                    </div>
                    <div class="indicator__option padding__left">
                        <img src="@/assets/images/pdf/green-checkbox-img.png" /> <span>Manual</span>
                    </div>
                </div>
            </div>
            <div class="syllable__tracker__data__table">
                <div class="table__head__wrapper">
                    <div class="head__text__block">
                        <span>Vowels</span>
                        <p>as in...</p>
                    </div>
                    <div class="head__item__list">
                        <div class="head__item__block" v-for="(vowel, vIndex) in vowels" :key="`head-${vIndex}`">
                            <span class="phonetic-symbols">{{ vowel.symbol }}</span>
                            <div class="label"
                                :style="selectedVowel(vIndex + 1, vowel.symbol, true) || selectedVowel(vIndex + 1, vowel.short, true) ? { background: 'rgb(114 92 255)', color: '#fff' } : (selectedVowel(vIndex + 1, vowel.short) ? { background: 'rgb(54, 194, 122)', color: '#fff' } : {})">
                                <span style="transform: translateY(-5px);font-weight: 600;" :style="selectedVowel(vIndex + 1, vowel.symbol, true) || selectedVowel(vIndex + 1, vowel.short, true) ? { color: '#fff' } : (selectedVowel(vIndex + 1, vowel.short) ? { color: '#fff' } : {})">{{ vowel.short }}</span>
                            </div>
                            <span style="height: 60px;">{{ vowel.example }}</span>
                        </div>
                    </div>
                </div>
                <div class="spacing">
                    <div class="sepline__divider"></div>
                </div>
                <div class="syllable__tracker__data__list__wrapper">
                    <div class="pb__10px" v-for="(row, cIndex) in consonantRows" :key="row.label">
                        <div class="row__item__block">
                            <div class="label__title__block">
                                <span style="transform: translateY(-5px);font-weight: 600;">{{ row.label }} {{ row.label
                                    == 'y'
                                    ? '(you)' : '' }}</span>
                            </div>
                            <div class="checkbox__group__wrapper">
                                <div class="checkbox__inline" v-for="(vowel, vIndex) in vowels"
                                    :key="`${row.code}-${vIndex}`">
                                    <span class="checkbox">
                                        <img src="@/assets/images/pdf/purple-checkbox-img.png"
                                            v-if="automated(row.label, vowel.symbol) || automated(row.label, vowel.short)" />
                                        <img src="@/assets/images/pdf/green-checkbox-img.png"
                                            v-else-if="manual(getIndexNo(cIndex, vIndex), row.label, vowel.short)" />
                                        <span class="blank__checkbox" v-else></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="mini__program__plan">
            <div class="page__head__block">
                <p class="head__title">Skills Preferences Match-Up</p>
            </div>
            <div class="pb__10px">
                <div class="faq__info__block__wrapper">
                    <div class="pb__20px">
                        <div class="faq__block__item">
                            <p>Speech skills can be matched with preferences that “sound like” syllables the learner can
                                echo. Info sources: EESA - R test results, Syllable Tracker (In EESA guide, Chapter 4
                                and
                                Appendix A)</p>
                        </div>
                    </div>
                    <div class="faq__block__item">
                        <p><strong>Directions</strong></p>
                        <ul>
                            <li>
                                <p>Write any syllable combinations from Syllable Tracker (Task 3) that “Sound Like”
                                    Preferred items on preference list above.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="skills__preferences__box__wrapper">
                <div class="pb__20px" v-for="(group, index) in skills_preferences_matchup" :key="index">
                    <div class="skill__preferences__row">
                        <span class="number__text">{{ index + 1 }}.</span>
                        <div class="text__block__wrapper">
                            <span>Syllable Combo</span>
                            <div class="text__wrapper">
                                <p>{{ group.sc ?? 'No' }}</p>
                            </div>
                        </div>
                        <div class="text__block__wrapper">
                            <span>Sounds Like</span>
                            <div class="text__wrapper">
                                <p>{{ group.sl ?? 'No' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="mini__program__plan" style="height: auto; max-height: fit-content; overflow: visible;">
            <div class="page__head__block">
                <p class="head__title">Program Targets</p>
            </div>
            <div class="pb__10px">
                <div class="faq__info__block__wrapper">
                    <div class="pb__20px">
                        <div class="faq__block__item">
                            <p>Info sources: Step 4c combinations, Shells info (in EESA Guide, Chapter 4 and Appendix A)
                            </p>
                        </div>
                    </div>
                    <div class="faq__block__item">
                        <p><strong>Directions</strong></p>
                        <ul>
                            <li>
                                <p>Write syllable approximations (if needed) from current skill to final target.</p>
                            </li>
                            <li>
                                <p>In training, reinforce vocals at each step, moving toward the terminal target.
                                    Example:
                                    “movie” in 4 steps: (1) oo (2) oo-ee (3) moo-ee (4) moo-vee</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="target__keys__wrapper">
                <h4 class="section__title">Key: T = Target</h4>
                <div class="target__key__list__wrapper" style="display: flex;gap: 10px; flex-wrap: wrap; ">
                    <div v-for="(target, tIndex) in programTargets" :key="tIndex" :style="{
                        padding: '20px',
                        borderRadius: '10px',
                        backgroundColor: '#F6F2FD',
                        marginTop: tIndex > 0 ? '0' : '0',
                        flex: '0 0 calc(50% - 5px)'
                    }">
                        <h3 style="float: left; margin-right:20px;">T<sub>{{ tIndex + 1 }}</sub></h3>
                        <h3>{{ target.header }}</h3>
                        <div style="margin-top: 15px; width: 100%;">
                            <div v-for="(input, iIndex) in target.inputs" :key="iIndex"
                                style="display: flex; align-items: center; margin-bottom: 15px; height: 60px;width: 100%;">
                                <!-- Key Box -->
                                <div
                                    style="height: 45px;width: 20%; background-color: #fff; border-radius: 8px; padding: 10px; display: flex; align-items: center; justify-content: center;">
                                    <span style="transform: translateY(-5px);font-weight: 600;">{{ Object.keys(input)[0]
                                        }}</span>
                                </div>

                                <!-- Spacer -->
                                <div style="width: 1%;"></div>

                                <!-- Value Box -->
                                <div
                                    style="width: 79%; background-color: white; border-radius: 8px; padding: 10px; display: flex; align-items: center; height: 45px;">
                                    <span style="transform: translateY(-5px);font-weight: 600;">{{
                                        input[Object.keys(input)[0]]
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { formatConsonants, formatSuperscript } from '@/utils/format-helpers';
import { handleError } from '@/utils/handleError';
import html2pdf from 'html2pdf.js';
import { computed, reactive, ref } from 'vue';
import { EESA_SCOPE_NOTE } from '@/utils/assessment-notes';
import {
    noTargetsIndicated,
    NO_TARGETS_HEADING,
    NO_TARGETS_INTRO,
    NO_TARGETS_INTRO_REF,
    NO_TARGETS_ACTIVITIES_LEAD,
    NO_TARGETS_ACTIVITIES,
    NO_TARGETS_ACTIVITIES_REF,
    NO_TARGETS_CLOSING,
} from '@/utils/assessment-targets';

const loader = useLoaderStore();

const scoreRanges = [
    {
        label: 'Low Accurary',
        range: '(0-9)',
        condition: (sum) => sum <= 9,
        tip: 'Strengthen skills at this level before increasing SC',
    },
    {
        label: 'Low Accurary',
        range: '(10-19)',
        condition: (sum) => sum >= 10 && sum <= 19,
        tip: 'OK to toggle * this SC level with next higher level',
    },
    {
        label: 'Low Accurary',
        range: '(20-25)',
        condition: (sum) => sum >= 20,
        tip: 'Go to next higher SC level',
    },
];

const errorAnalysisTips = [
    {
        points: '20-25',
        tip: 'Target vowels and diphthongs in 2-syllable strings. Achieve accuracy on these before increasing syllable complexity.',
        condition: (sum) => sum >= 20,
    },
    {
        points: '10-19',
        tip: 'Target vowels/diphthongs in 2-syllable strings. Monitor for consonant deletions. Alternate target syllable complexity between achieved and need-to-achieve for Group 2.',
        condition: (sum) => sum >= 10 && sum <= 19,
    },
    {
        points: '0-9',
        tip: 'Monitor vowel accuracy and consonant inclusion in 2-3 syllable strings at SC code levels in Work Packet, Group 2 SC Analysis. See above if accuracy is not progressing.',
        condition: (sum) => sum <= 9,
    },
];

const vowels = [
    { symbol: "i", short: "ee", example: "see" },
    { symbol: "ɪ", short: "ih", example: "itch" },
    { symbol: "e", short: "ay", example: "say" },
    { symbol: "ɛ", short: "eh", example: "bed" },
    { symbol: "æ", short: "(none)", example: "cat" },
    { symbol: "a", short: "ah", example: "top" },
    { symbol: "ʌ or ə", short: "uh", example: "bug\n awake" },
    { symbol: "ʊ", short: "(none)", example: "foot" },
    { symbol: "ɔ", short: "aw", example: "law" },
    { symbol: "o", short: "oh", example: "go" },
    { symbol: "u", short: "oo", example: "boo" },
    { symbol: "au", short: "ow", example: "pow" },
    { symbol: "aɪ", short: "ai", example: "eye" },
    { symbol: "oɪ", short: "oi", example: "boy" },
];

const consonantRows = [
    { label: "w or wh", code: "wh" },
    { label: "h", code: "h" },
    { label: "p or b", code: "pb" },
    { label: "t or d", code: "td" },
    { label: "k or g", code: "kg" },
    { label: "m", code: "m" },
    { label: "n", code: "n" },
    { label: "ng or ŋ", code: "ngŋ" },
    { label: "f or v", code: "fv" },
    { label: "l", code: "l" },
    { label: "y or j", code: "yj" },
];

const initNote = [
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" },
    { "sc": "", "sl": "" }
];

const props = defineProps({
    organizationId: Number,
    assessmentId: Number,
    learnerId: Number,
    buttonLabel: {
        type: String,
        default: 'Download'
    },
});

const pdfSource = ref(null);

const assessment = ref(null);

const learnerName = computed(() => `${assessment.value?.learner?.firstname} ${assessment.value?.learner?.lastname}` || '');

const groupScores = computed(() => assessment.value?.result?.group_scores || []);
const scvAverages = computed(() => assessment.value?.result?.scv_averages || []);
const skip_group = computed(() => (assessment.value?.skip_group1 == 1 || assessment.value?.skip_group2 == 1));
const skills_preferences_matchup = computed(() => {
    const note = assessment.value?.note?.skills_preferences_matchup;
    return (note) ? JSON.parse(note) : initNote
});

const programTargets = computed(() => {
    const note = assessment.value?.note?.program_targets ?? null;
    return (note) ? JSON.parse(note) : [{
        header: '',
        inputs: [
            { end: '' },
            { '...': '' },
            { start: '' }
        ]
    }];
});

const workpacket = reactive({
    group1: null,
    group2: null,
    group3: null,
});

const workpacketData = ref(null);

const paginatedGroupQuestions = (group) => {
    const questions = [
        ...(workpacket[`group${group}`]?.groupQuestions || []),
        ...(workpacket[`group${group}`]?.groupQuestionsRemoved || []).map(q => ({ ...q, removed: true }))
    ];

    const chunked = [];

    let limit = 10;

    for (let i = 0; i < questions.length; i += limit) {
        if (i > 0) limit = 14;
        chunked.push(questions.slice(i, i + limit));
    }

    return chunked;
};

const avgScoreOnePrecentage = computed(() => {
    let a = {};

    Object.entries(groupScores.value).forEach(([group, data]) => {
        a[group] = data.total > 0 ? (data.score_one / data.total) * 100 : 0;
    });

    return a;
});

const noTargets = computed(() => noTargetsIndicated(avgScoreOnePrecentage.value));

const activeTargetIndex = computed(() => {
    const s = avgScoreOnePrecentage.value;

    // If Group 1 < 80 → active is 1
    if (s[1] < 80) return 1;

    // Walk through 2..5
    for (let i = 2; i <= 5; i++) {
        // If previous wasn't ≥ 80, keep last one active
        if (s[i - 1] < 80) return i - 1;

        // Previous ≥ 80 and current < 80 → current is active
        if (s[i] < 80) return i;
    }

    // All groups ≥ 80 → last one active
    return 5;
});

// Precompute activations without recursion
const groupTargetActivation = computed(() => {
    const idx = activeTargetIndex.value;
    return {
        1: idx === 1,
        2: idx === 2,
        3: idx === 3,
        4: idx === 4,
        5: idx === 5
    };
});

// Checkbox configuration by group
const checkboxConfig = computed(() => ({
    1: [
        {
            condition: avgScoreOnePrecentage.value[1] < 80 || avgScoreOnePrecentage.value[1] >= 80,
            label: 'Start targets at this SC level'
        },
        {
            condition: avgScoreOnePrecentage.value[1] >= 80 && (avgScoreOnePrecentage.value[2] < 80 || avgScoreOnePrecentage.value[2] >= 80),
            label: 'See Group 2 for guidance'
        }
    ],
    2: [
        {
            condition: avgScoreOnePrecentage.value[1] >= 80 && (avgScoreOnePrecentage.value[2] < 80 || avgScoreOnePrecentage.value[2] >= 80),
            label: 'Start targets at this SC level or lower'
        },
        {
            condition: avgScoreOnePrecentage.value[2] >= 80 && (avgScoreOnePrecentage.value[3] < 80 || avgScoreOnePrecentage.value[3] >= 80),
            label: 'See Group 3 for guidance'
        }
    ],
    3: [
        {
            condition: avgScoreOnePrecentage.value[2] >= 80 && (avgScoreOnePrecentage.value[3] < 80 || avgScoreOnePrecentage.value[3] >= 80),
            label: 'Start targets at this SC level or lower'
        },
        {
            condition: avgScoreOnePrecentage.value[3] >= 80 && (avgScoreOnePrecentage.value[4] < 80 || avgScoreOnePrecentage.value[4] >= 80),
            label: 'See Group 4 for guidance'
        }
    ],
    4: [
        {
            condition: avgScoreOnePrecentage.value[3] >= 80 && (avgScoreOnePrecentage.value[4] < 80 || avgScoreOnePrecentage.value[4] >= 80),
            label:
                'Target highest-achieved SC Levels <span class="check__info">(Probable Group 2 or 1) and Toggle* between 2 and 3 syllable combos; advance to 3 - 4</span>'
        },
        {
            condition: avgScoreOnePrecentage.value[4] >= 80 && (avgScoreOnePrecentage.value[5] < 80 || avgScoreOnePrecentage.value[5] >= 80),
            label:
                'Target highest-achieved SC Levels <span class="check__info">(Probable Group 3 or 2) and Toggle* between 3 and 4 syllable combos; advance to 4 - 5</span>'
        }
    ],
    5: [
        {
            condition: avgScoreOnePrecentage.value[4] >= 80 && (avgScoreOnePrecentage.value[5] < 80 || avgScoreOnePrecentage.value[5] >= 80),
            label:
                'Target highest-achieved SC Levels <span class="check__info">(Probable Group 3 or 2) and Toggle* between 3 and 4 syllable combos; advance to 4 - 5, 5 - 6, and 6+</span>'
        },
        {
            condition: avgScoreOnePrecentage.value[5] >= 80,
            label:
                'If all Group scores are high, specific intervention for echoic skills may not be needed (See guide, Chapter 3, EESA - R General Information)'
        }
    ]
}));

const getRange = computed(() => {
    const scores = avgScoreOnePrecentage.value ?? [];

    const g1 = scores[1] ?? 0;
    const g2 = scores[2] ?? 0;
    const g3 = scores[3] ?? 0;
    const g4 = scores[4] ?? 0;
    const g5 = scores[5] ?? 0;

    if (g1 >= 80 && g2 >= 80 && g3 >= 80 && g4 < 80) {
        return '2 - 3';
    }

    if (g1 >= 80 && g2 >= 80 && g3 >= 80 && g4 >= 80 && g5 < 80) {
        return '3 - 4';
    }

    if (g1 >= 80 && g2 >= 80 && g3 >= 80 && g4 >= 80 && g5 >= 80) {
        return '4 - 5';
    }

    return '  -  ';
});

const getMaxSCVAverages = computed(() => {
    const values = Object.values(scvAverages.value);

    const maxSyllable = Math.max(
        ...values.map(v => parseFloat(v.syllable) || 0)
    );
    const maxConsonant = Math.max(
        ...values.map(v => parseFloat(v.consonant) || 0)
    );
    const maxVowel = Math.max(
        ...values.map(v => parseFloat(v.vowel) || 0)
    );

    return {
        syllable: maxSyllable,
        consonant: maxConsonant,
        vowel: maxVowel
    };
});

const automated = (consonant, vowel) => {
    // If not loaded yet → always false
    if (!workpacketData.value || !workpacketData.value?.syllableTracker) {
        return false;
    }

    const consonants = consonant.split(/or/i).map(s => s.trim().toLowerCase());
    const vowels = vowel.split(/or/i).map(s => s.trim().toLowerCase());

    const matches = [];

    consonants.forEach(c => {
        vowels.forEach(v => {
            const key = `${c}${v}`;
            if (workpacketData.value?.syllableTracker?.[key] === 1) {
                matches.push(key);
            }
        });
    });

    return matches.length > 0 ?? false;
}

const manual = (indexNo, consonant, vowel) => {
    const manualTracker = workpacketData.value?.manualSyllableTracker?.[indexNo]

    if (manualTracker) {
        const manualTrackerJson = JSON.parse(manualTracker);

        const consonants = consonant.split(/or/i).map(s => s.trim().toLowerCase());
        const matches = consonants.map(c => `${c}_${vowel}`).filter(key => {
            const keys = key.split('_');
            return manualTrackerJson?.[keys[0]] == 1 && manualTrackerJson?.[keys[1]] == 1;
        });

        return matches.length > 0 ?? false;
    }

    return false;
}

const selectedVowel = (indexNo, vowel, automate = false) => {
    if (automate) {
        const syllableTracker = workpacketData.value?.syllableTracker;
        if (!syllableTracker) return false;
        const vowels = vowel.split(/or/i).map(v => v.trim());
        return vowels.some(v => syllableTracker[v] === 1);
    } else {
        const manualTracker = workpacketData.value?.manualSyllableTrackerVowel?.[indexNo];
        if (manualTracker) {
            const manualTrackerJson = JSON.parse(manualTracker);
            return manualTrackerJson?.[vowel] == 1
        }

        return false;
    }
}

const getIndexNo = (cIndex, vIndex) => (cIndex * vowels.length + vIndex + 1);

const jsonDecodeNote = (note) => {
    return (note) ? JSON.parse(note) : {
        activities: "",
        items: "",
        places: ""
    }
}

const fetchData = async () => {
    loader.show();
    try {
        const { data } = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}`);
        assessment.value = data?.data;

        for (let i = 1; i <= 3; i++) {
            const { data } = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/workpacket`, {
                params: {
                    group: i
                }
            });

            workpacket[`group${i}`] = data?.data;
        }

        const workpacketdata = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/workpacket`);

        workpacketData.value = workpacketdata?.data?.data;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const downloadPDF = async () => {
    try {
        loader.show();
        await fetchData();

        const source = pdfSource.value;
        if (!source) return;

        const clone = source.cloneNode(true);
        clone.id = 'pdfContent__temp';
        clone.style.display = 'block';
        clone.style.width = '100%'; // Ensure full width rendering
        document.body.appendChild(clone); // Attach so styles are applied

        // Wait for images/fonts to load before rendering
        await Promise.all(
            Array.from(clone.querySelectorAll('img')).map(img => {
                if (!img.complete) {
                    return new Promise(resolve => {
                        img.onload = img.onerror = resolve;
                    });
                }
            })
        );
        await document.fonts.ready;

        const learnerName = `${assessment.value?.learner?.firstname} ${assessment.value?.learner?.lastname}`;

        const opt = {
            margin: 0,
            filename: `EESA Work Packet - ${learnerName}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                scrollX: 0,
                scrollY: 0
            },
            jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
        };

        // const pdfUrl = await html2pdf().set(opt).from(clone).outputPdf('bloburl');
        // window.open(pdfUrl, '_blank');
        await html2pdf().set(opt).from(clone).toPdf().save();

        clone.remove();
        loader.hide();
    } catch (error) {
        loader.hide();
        handleError(error);
    }
};

const paginatedMiniProgramPlan = (targets) => {
    const targetList = JSON.parse(targets);

    const chunked = [];

    let limit = 4;

    for (let i = 0; i < targetList.length; i += limit) {
        if (i > 0) limit = 10;
        chunked.push(targetList.slice(i, i + limit));
    }

    return chunked;
};

</script>
<style scoped>
*,
*::before,
*::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-size: 13px;
}

.pdf-page {
    /* A4 height in px at 96 DPI */
    background-color: #e8f2fc;
    font-family: 'Poppins';
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body,
html {
    background-color: #e8f2fc !important;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

section {
    width: 794px;
    height: 1122px;
    background-color: #e8f2fc;
    max-height: 1123px;
    overflow: hidden;
}

.phonetic-symbols {
    font-family: 'DejaVu Sans', sans-serif !important;
}


.table__data__row>*,
.target__value__row>* {
    margin-top: -5px;
}

.table__data__row__block.text-label>* {
    margin-top: -20px;
}

.example__row__list__wrapper .row__item__block>* {
    width: 33%;
    margin-top: -15px;
}

.example__row__list__wrapper .row__item__block {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}


/*---Work Packet PDF Page--*/
.work__packet__pdf__page {
    background-color: #e8f2fc;
    width: 100%;
}

.work__packet__pdf__page .sideimg__block {
    line-height: 0px;
    width: 29%;
    display: inline-block;
    vertical-align: top;
    /* background-color: red; */
}

.work__packet__pdf__page .content__block__wrapper {
    display: inline-block;
    vertical-align: top;
    width: 70%;
    text-align: center;
    padding-top: 100px;
    /* background-color: purple; */
}

.work__packet__pdf__page .content__block__wrapper .logo__wrap {
    max-width: 250px;
    margin: 0px auto;
    padding-bottom: 80px;
}

.work__packet__pdf__page .content__block__wrapper .main__title {
    color: #1f3479;
    font-family: 'Poppins';
    font-size: 64px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    padding-bottom: 50px;
    text-align: center;
}

.work__packet__pdf__page .content__block__wrapper .sub__title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding-bottom: 50px;
    text-align: center;
}

.work__packet__pdf__page .content__block__wrapper .text__wrapper {
    max-width: 380px;
    margin: 0px auto;
    text-align: left;
    font-family: 'Poppins';
}

.work__packet__pdf__page .content__block__wrapper .text__wrapper p {
    padding-bottom: 30px;
    font-size: 13px;
    font-weight: 500;
}

.page__head__block {
    padding: 30px 15px;
    border-radius: 25px;
    background: #FFF;
    margin-bottom: 20px;
}

.page__head__block .head__title {
    color: #111610;
    font-size: 25px;
    font-style: normal;
    font-family: 'Poppins';
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.01px;
    margin-top: -25px;
}

.page__head__block .para {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

/*---Work Packet PDF Page--*/

/*---Information PDF Page--*/
.information__pdf__page .cover__wrapper {
    background-color: #e8f2fc;
    padding: 20px;
}

.information__pdf__page img {
    max-width: 100%;
}

.information__pdf__page .main__body__wrapper {
    padding: 15px;
    border-radius: 25px;
    background: #FFF;
}

.information__pdf__page .main__body__wrapper .img__wrapper {
    line-height: 0px;
    padding-bottom: 50px;
}

.information__pdf__page .content__block__wrap h3.title {
    color: #10223b;
    font-family: 'Poppins';
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding-bottom: 15px;
}

.information__pdf__page .content__block__wrap .description__wrapper {
    color: #5c667f;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-top: 20px;
    /* Added padding to ensure top space */
}

.content__block__wrap .description__wrapper p {
    padding-bottom: 30px;
}

/*---Information PDF Page--*/

/*---Result Summary PDF Page--*/
.result__summary__pdf__page .cover__wrapper {
    background-color: #e8f2fc;
    padding: 20px;
}

.result__summary__pdf__page .result__group__wrapper {
    padding: 10px;
    border-radius: 15px;
    background-color: #ffffff;
}

.result__group__wrapper .group__row__block {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.result__group__wrapper .group__row__block .group__block__item {
    border-radius: 10px;
    background-color: #f6f2fd;
    padding: 10px;
    width: 48.6%;
    margin: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}


.group__block__item .group__text__wrapper {
    margin: 0px !important;
}

.group__block__item .result__round__box {
    width: 75px;
    height: 75px;
    background-color: #725CFF;
    border-radius: 100%;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: center;
}

.group__block__item.color3 .result__round__box,
.group__block__item.color4 .result__round__box {
    background-color: #ffb42b;
}

.group__block__item.color5 .result__round__box {
    background-color: #2d79c3;
}

.group__block__item .result__round__box span {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    margin-top: -20px;
}

.group__block__item .group__text__wrapper label {
    display: block;
    color: #111610;
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 20px;
}

.group__block__item .group__text__wrapper span {
    display: block;
    color: #111610;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 20px;
}

.result__group__wrapper .group__row__block .group__block__item.color2 {
    background-color: #e8f2fc;
}

.result__group__wrapper .group__row__block .group__block__item.color3 {
    background-color: #F7F3ED;
}

.result__group__wrapper .group__row__block .group__block__item.color4 {
    background-color: #FFFAE5;
}

.result__group__wrapper .group__row__block .group__block__item.color5 {
    background-color: #DBF1F3;
}

.group__text__wrapper {
    /* background-color: red; */
    display: inline-block;
    vertical-align: middle;
    width: 65%;
}


/*---------------- Voice Bank ----------------*/
.result__summary__pdf__page .voice__bank__wrapper h4.title {
    font-size: 18px;
    line-height: 1.3;
    padding-bottom: 15px;
}

.result__summary__pdf__page .voice__bank__wrapper {
    padding: 15px;
    border-radius: 25px;
    background-color: #ffffff;
}

.voice__bank__wrapper .divider__sepline {
    background-color: #8F959C;
    height: 2px;
    width: 100%;
}

.voice__bank__wrapper .voice__bank__list__block {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.voice__bank__wrapper .voice__bank__item {
    border-radius: 15px;
    background-color: #f6f2fd;
    padding: 20px 20px 30px;
    display: inline-block;
    vertical-align: top;
    width: 48.6%;
    margin-bottom: 20px;
}

.voice__bank__wrapper .voice__bank__item h6.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 8px;
    margin-top: -10px;
}

.voice__bank__wrapper .voice__bank__item .sepline {
    height: 2px;
    width: 100%;
    background-color: #d1c6c6;
}

.voice__bank__item .value__group__wrap {
    padding-top: 12px;
}

.voice__bank__item .value__group__wrap .value__box {
    display: inline-block;
    vertical-align: top;
    width: 32.3%;
}

.value__group__wrap .value__box label {
    display: block;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.value__group__wrap .value__box span {
    display: block;
    color: #111610;
    font-family: 'Poppins';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding-top: 5px;
}

.voice__bank__wrapper .voice__bank__item.color2 {
    background-color: #e8f2fc;
}

.voice__bank__wrapper .voice__bank__item.color3 {
    background-color: #f7f3ed;
}

.voice__bank__wrapper .voice__bank__item:first-child {
    margin-top: 0px;
}

/*---Result Summary PDF Page--*/


/*---Analysis PDF Page--*/
.analysis__group__pdf__page {
    background-color: #e8f2fc;
    padding: 20px;
}

.analysis__group__pdf__page .page__header__block {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
}

.analysis__group__pdf__page .page__header__block .page__title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: 20px;
    font-weight: 600;
    line-height: normal;
    /* padding-bottom: 10px; */
}

.analysis__group__pdf__page .page__header__block p.subtitle {
    display: block;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.analysis__group__pdf__page .analysis__info__block {
    /* width: 100%; */
    padding: 15px;
    border-radius: 20px;
    background-color: #ffffff;
}

.analysis__info__block .info__table__block {
    border-radius: 20px;
    background-color: #e8f2fc;
    padding: 15px;
}

.info__table__block .title__group {
    margin-top: -10px;
}

.info__table__block .info__block__wrapper {
    padding-bottom: 5px;
}

.info__table__block .title__group label {
    width: 49.5%;
    display: inline-block;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    vertical-align: middle;
}

.info__table__block .title__group label:nth-child(2) {
    text-align: right;
}

.analysis__info__block .info__table__block .sepline__divider {
    width: 100%;
    height: 1px;
    background-color: #8f959c;
}

.analysis__info__block .info__table__block .spacing {
    padding: 10px 0px;
}

.info__block__wrapper .info__text__wrap {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: inline-block;
    vertical-align: top;
    width: 49.5%;
}

.info__block__wrapper .info__text__wrap.right {
    text-align: right;
}

.info__block__wrapper .info__text__wrap.left {
    text-align: left;
}

.info__block__wrapper .info__text__wrap.text-a {
    width: 65%;
}

.info__block__wrapper .info__text__wrap.text-b {
    width: 34%;
    text-align: right;
}

.analysis__group__pdf__page .analysis__table__data__block {
    /* width: 100%; */
    padding: 15px;
    border-radius: 20px;
    background-color: #ffffff;
}

.analysis__group__pdf__page .analysis__table__data__block .table__data__block {
    border-radius: 20px;
    border: 1px solid #dee2e7;
    background-color: #ffffff;
    padding: 20px;
    /* display: inline-block; */
    vertical-align: top;
    /* width: 100%; */
}

.analysis__table__data__block .spacing__cover__right {
    /* padding-right: 10px; */
    /* display: inline-block; */
    vertical-align: top;
    /* width: 49.5%; */
    /* background-color: red; */
    /* padding-bottom: 20px; */
}

.analysis__table__data__block .spacing__cover__left {
    /* padding-left: 10px; */
    /* display: inline-block; */
    vertical-align: top;
    /* width: 50%; */
    /* background-color: greenyellow;            */
}

.table__data__block .table__head__block .head__item {
    display: inline-block;
    vertical-align: middle;
    width: 32.5%;
}

.table__head__block .head__item label {
    display: block;
    padding-bottom: 2px;
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.table__head__block .head__item span {
    display: block;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.head__item .group__numbers span {
    color: #3f444a;
    text-align: center;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: inline-block;
    vertical-align: middle;
    width: 30%;
}

.tar {
    text-align: right !important;
}

.tal {
    text-align: left !important;
}

.tac {
    text-align: center !important;
}

.table__data__block .spacing {
    padding: 20px 0px;
}

.table__data__block .sepline__divider {
    width: 100%;
    height: 1px;
    background-color: #8f959c;
}

.table__data__list__wrapper .table__data__row .data__item {
    display: inline-block;
    vertical-align: middle;
    width: 32.3%;
}

.table__data__row .data__item.combine__value span {
    color: #3f444a;
    text-align: center;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: inline-block;
    vertical-align: middle;
    width: 30%;
}

.table__data__row .data__item label {
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: block;
    padding-bottom: 2px;
}

.table__data__row .data__item span {
    color: #111610;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: block;
}

.table__data__list__wrapper .table__data__row {
    padding: 10px 12px 20px;
    /* width: 100%; */
}

.table__data__list__wrapper .table__data__row+.table__data__row {
    border-top: 1px solid #bcc7ba;
}

.table__data__row.purple__row {
    background-color: #725cff;
}

.table__data__row.gray__row {
    background-color: #dee2e7;
}

.table__data__row.red__row {
    background-color: rgb(245 212 205);
}

.table__data__row.purple__row span,
.table__data__row.purple__row label {
    color: #ffffff !important;
}

.table__data__row.gray__row span,
.table__data__row.gray__row label {
    color: #8f959c !important;
}

.pb__30px {
    padding-bottom: 30px;
}

/*---Analysis PDF Page--*/

/* ================================== */
.analysis__group__pdf__page h4.head__title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    /* padding-bottom: 10px; */
}

.analysis__group__pdf__page .para {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

/* ===================================== */

/*---Target Guide PDF Page--*/

.target__data__cover {
    padding: 15px;
    border-radius: 20px;
    background-color: #ffffff;
}

.target__head__title .head__label {
    display: inline-block;
    vertical-align: middle;
    width: 32.5%;
}

.target__head__title .head__label label {
    display: block;
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.analysis__group__pdf__page .target__head__title {
    padding-bottom: 12px;
}

.analysis__group__pdf__page .target__value__row {
    border-radius: 20px;
    background-color: #e8f2fc;
    padding: 10px 10px 20px;
    margin-bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
}

.analysis__group__pdf__page .target__value__row.active__target__group {
    background-color: #725cff;
}

.analysis__group__pdf__page .target__value__row.active__target__group .data__value__text label,
.analysis__group__pdf__page .target__value__row.active__target__group .data__value__text p,
.analysis__group__pdf__page .target__value__row.active__target__group .data__value__text span {
    color: #fff;
}

.general__tips__box p {
    font-size: 12px;
    margin-top: -10px;
}

.data__value__text label {
    color: #111610;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
}

.data__value__text span {
    display: block;
    color: #111610;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.2;
}

.analysis__group__pdf__page .target__value__row .data__value__text {
    width: 30%;
}


.data__value__text.combine__value {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    vertical-align: top;
    width: 31%;
}

.data__value__text.combine__value {
    margin-left: 12px;
    margin-bottom: 0px;
}

.data__value__text.general__tips__box {
    border-radius: 10px;
    border: 1px dashed #725cff;
    padding: 10px;
    color: #111610;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin-left: 12px;
    margin-top: 5px;
}

.pb12 {
    padding-bottom: 10px;
}

.mb12 {
    margin-bottom: 10px !important;
}

.target__analysis__info__block {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.target__analysis__info__block .info__block__wrapper {
    border-radius: 20px;
    background-color: #e8f2fc;
    padding: 20px;
    /* width: 100%; */
}

.target__analysis__info__block .info__block__wrapper h4.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-bottom: 5px;
}

.target__analysis__info__block .info__block__wrapper .text__wrapper {
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.info__block__wrapper .text__wrapper p+p {
    padding-top: 5px;
    font-size: 14px;
}

.target__analysis__data__list .target__data__item {
    border-radius: 20px;
    background-color: #e8f2fc;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.target__analysis__data__list .target__data__item.active__target__group {
    background-color: #725cff;
}

.target__data__item .value__text__block {
    width: 18%;
    /* display: inline-block; */
    vertical-align: middle;
    /* padding-right: 20px; */
    /* background: red; */
    margin-top: -20px;
}

.target__data__item .value__text__block label {
    display: block;
    color: #111610;
    text-align: center;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.target__analysis__data__list .target__data__item.active__target__group label {
    color: #fff;
}

.target__analysis__data__list .target__data__item.active__target__group p {
    color: #000;
    font-size: 14px;
}

.target__data__item .value__text__block span {
    display: block;
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
}

.target__data__item .data__info__block {
    border-radius: 10px;
    background-color: #ffffff;
    color: #111610;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 10px 10px 15px;
    width: 78%;
    display: inline-block;
    vertical-align: middle;
    /* margin-left: 60px; */
    /* background: green; */
}

.target__data__item .data__info__block p {
    margin-top: -10px;
}

/* .pt20 {
                padding-top: 20px;
            } */
/*---Target Guide PDF Page--*/



.starting__targets__pdf__page {
    background-color: #e8f2fc;
    padding: 20px;
}

.starting__targets__pdf__page .page__header__block {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 25px;
}

.tar {
    text-align: right !important;
}

.tal {
    text-align: left !important;
}

.tac {
    text-align: center !important;
}

.pb__20px {
    padding-bottom: 12px;
}

.starting__targets__pdf__page h4.head__title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.starting__targets__pdf__page .para {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.starting__targets__pdf__page .table__data__block {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.starting__targets__pdf__page .no__targets__block {
    margin-top: 25px;
}

.starting__targets__pdf__page .no__targets__block .head__title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 25px;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 10px;
}

.starting__targets__pdf__page .no__targets__block .para {
    margin-bottom: 10px;
}

.starting__targets__pdf__page .no__targets__block .page__ref {
    font-size: 15px;
    color: #6b7075;
}

.starting__targets__pdf__page .no__targets__list {
    list-style: disc;
    padding-left: 30px;
    margin-bottom: 10px;
}

.starting__targets__pdf__page .no__targets__list li {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 20px;
    font-weight: 400;
    line-height: 1.4;
}

.starting__targets__pdf__page .no__targets__list strong {
    font-weight: 600;
    color: #111610;
}

.starting__targets__pdf__page .table__head__block span {
    color: #111610;
    text-align: right;
    font-family: 'Poppins';
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.4;
    display: inline-block;
    width: 49%;
}

.sepline__divider {
    width: 100%;
    height: 1px;
    background-color: #8f959c;
}

.spacing {
    padding: 20px 0px;
}

.table__data__list__block .table__data__row__block {
    border-radius: 15px;
    background-color: #e8f2fc;
    padding: 15px 15px 0px 15px;
}

.table__data__list__block .text-label {
    padding-bottom: 10px;
    min-height: 100px;
    display: flex;
    align-items: center;
}

.table__data__list__block .table__data__row__block .row__label {
    display: inline-block;
    color: #111610;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    vertical-align: middle;
    width: 10%;

}

.table__data__row__block .checkbox__group label {
    display: inline-block;
    vertical-align: middle;
    color: #111610;
    font-family: 'Poppins';
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
}

.table__data__row__block .checkbox__group input {
    display: inline-block;
    vertical-align: middle;
}

.table__data__list__block .table__data__row__block .checkbox__group {
    display: flex;
    vertical-align: middle;
    width: 44%;
    gap: 10px;
    align-items: center;
}

.table__data__list__block .table__data__row__block .checkbox__group img {
    height: 20px;
    width: 20px;
    margin-top: 15px;
}

.checkbox__group .label__text__wrapper {
    display: inline-block;
    width: 90%;
    vertical-align: middle;
    padding-left: 10px;
}

.checkbox__group .label__text__wrapper label {
    display: block;
}

.checkbox__group .label__text__wrapper .text__wrapper {
    color: #3f444a;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
}

.table__data__row__block .check-box {
    margin-bottom: 0 !important;
    padding-top: 10px;

}

.pb__10px {
    padding-bottom: 10px;
}

.pb__15px {
    padding-bottom: 15px;
}

.mb__15px {
    margin-bottom: 15px;
}

.pt__15px {
    padding-top: 15px;
}


/* Starting Targets - Syllable Complexity  - A */
.heading__label__block span {
    display: block;
    color: #725cff;
    font-family: 'Poppins';
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.page__header__block .inline__block__wrap,
.page__header__block .heading__label__block {
    display: inline-block;
    vertical-align: middle;
}

.page__header__block .inline__block__wrap {
    width: 69%;
}

.page__header__block .heading__label__block {
    width: 29%;
}

.starting__targets__pdf__page .group__block__wrapper {
    border-radius: 26.822px;
    border: 1px solid #dee2e7;
    background-color: #dee2e7;
    padding: 15px;
}

.starting__targets__pdf__page .group__block__wrapper h4.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.group__block__wrapper .different__data__blocks .group__item__block {
    width: 31%;
    display: inline-block;
    vertical-align: top;
    /* background: red; */
}

.different__data__blocks .group__item__block+.group__item__block {
    padding-left: 20px;
}

.different__data__blocks .group__item__block .label__title {
    display: block;
    color: #8f959c;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 15px;
}

.number__group__wrap .number {
    color: #d4d4d4;
    text-align: center;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-radius: 10px;
    background-color: #eaeef5;
    padding: 5px 0px;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.number__group__wrap .number p {
    margin-top: -15px;
}

.group__block__wrapper.purple__block .number__group__wrap .number {
    color: #000;
}

.starting__targets__pdf__page .group__block__wrapper.purple__block {
    background-color: #725cff;
    border-color: #725cff;
}

.check__group__box.active__check__group .table__data__row__block {
    background-color: #725cff;
    border-color: #725cff;
}

.check__group__box.active__check__group .table__data__row__block .row__label,
.check__group__box.active__check__group .table__data__row__block .checkbox__group label {
    color: #fff;
}

.starting__targets__pdf__page .group__block__wrapper.purple__block h4.title {
    color: #ffffff;
}

.purple__block .different__data__blocks .group__item__block .label__title {
    color: #ffffff;
}

.number__group__wrap .number.purple {
    background-color: #917aff;
    color: #ffffff;
}

.number__group__wrap .number.white {
    background-color: #ffffff;
    color: #917aff;
}


.starting__targets__pdf__page .starting__targets__group__block {
    border-radius: 20px;
    background-color: #dee2e7;
    padding: 15px;
}

.starting__targets__pdf__page .starting__targets__group__block.purple__block {
    background-color: #917aff;
}

.starting__targets__group__block h4.title {
    color: #fff;
    font-family: 'Poppins';
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.starting__targets__group__block .data__content__block span.title {
    color: #fff;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 20px;
    display: block;
}

.advance__group__block .arrow__btn {
    padding: 15px;
    line-height: 0px;
    width: 70px;
    display: inline-block;
    vertical-align: middle;
}

.advance__group__block .number__group__block {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.advance__group__block .number__group__block>div {
    border-radius: 12px;
    background-color: #917aff;
    padding: 16px;
    color: #fff;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.data__content__block .numbers__box>div {
    padding: 16px;
    color: #725cff;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    background-color: #ffffff;
    border-radius: 12px;
    width: 66.48px;
}

.advance__group__block .number__group__block>div>p,
.data__content__block .numbers__box>div>p {
    margin-top: -18px;
}

.data__content__block .numbers__box {
    padding-bottom: 20px;
}

.starting__targets__example__wrapper {
    padding: 15px;
    border-radius: 20px;
    background-color: #ffffff;
}

.starting__targets__example__wrapper h6.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 20px;
}

.starting__targets__example__wrapper .example__table__block {
    display: block;
    padding: 20px;
    border-radius: 20px;
    border: 1px solid #8f959c;
}

.example__table__block .table__head__block .head__item {
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: inline-block;
    vertical-align: middle;
    width: 32%;
    /* background: yellowgreen; */
    text-align: left;
}

.example__row__list__wrapper .row__item__block {
    border-radius: 15px;
    background-color: #f6f2fd;
    padding: 15px;
    color: #111610;
    font-family: 'Poppins';
    font-weight: 500;
    line-height: normal;
}

.example__row__list__wrapper .row__item__block span {
    display: inline-block;
    width: 32.9%;
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.example__row__list__wrapper .row__item__block.purple__row {
    background-color: #725cff;
    color: #fff;
}

.example__row__list__wrapper .row__item__block.purple__row span {
    color: #ffffff;
}

/* Mini - Program Plan */
.mini__program__plan {
    background-color: #e8f2fc;
    padding: 20px;
}

.mini__program__plan .page__header__block {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
}

.mini__program__plan .para {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.mini__program__plan h4.head__title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.mini__program__plan .info__wrapper {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 20px;
}

.mini__program__plan .info__wrapper>* {
    margin-top: -10px;
}

.mini__program__plan .info__wrapper p+p {
    padding-top: 10px;
}

.syllable__range__block__wrapper {
    border-radius: 20px;
    background-color: #725cff;
    padding: 15px;
}

.syllable__range__block__wrapper span.title {
    color: #fff;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: block;
    padding-bottom: 20px;
}

.syllable__range__block__wrapper .label__tag__block {
    padding-bottom: 20px;
}

.syllable__range__block__wrapper .label__tag__block .number__tag {
    border-radius: 8px;
    background-color: #ffffff;
    padding: 8px 16px;
    color: #725cff;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: fit-content;
}

.data__value__wrapper .inline__box {
    display: inline-block;
    vertical-align: middle;
    width: 29.4%;
    /* background: goldenrod; */
}

.data__value__wrapper .inline__box+.inline__box {
    padding-left: 30px;
}

.data__value__wrapper .data__tag__wrap {
    border-radius: 8px;
    background-color: #917aff;
    padding: 16px 8px;
    width: 100%;
}

.data__value__wrapper .data__tag__wrap>* {
    margin-top: -20px;
}

.data__value__wrapper .data__tag__wrap span {
    display: inline-block;
    vertical-align: middle;
    width: 50%;
    color: #fff;
    text-align: center;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.data__value__wrapper .data__tag__wrap .number__text {
    font-size: 24px;
    font-weight: 600;
    line-height: normal;
}

.syllable__range__block__wrapper .data__value__wrapper {
    padding-bottom: 20px;
}

.syllable__range__block__wrapper .text__block__wrapper .label__title {
    color: #fff;
    font-family: 'Poppins';
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    padding-bottom: 8px;
}

.text__block__wrapper .text__area__block {
    color: #fff;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 15px 0px;
    /* height: 120px; */
}

.mini__program__plan .faq__info__block__wrapper {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.faq__info__block__wrapper .faq__block__item {
    border-radius: 10px;
    background-color: #e8f2fc;
    padding: 15px;
}

.faq__info__block__wrapper .faq__block__item p {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.faq__info__block__wrapper .faq__block__item p+p {
    padding-top: 8px;
}

.mini__program__plan .sub__title__block {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 25px;
}

.mini__program__plan .sub__title__block h4.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.label__tag__block .number__tag.disable {
    background-color: #dee2e7;
    color: #8f959c;
}

/* Syllable Tracker */
.syllable__tracker__data__table {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.syllable__tracker__data__table .table__head__wrapper .head__text__block {
    display: inline-block;
    vertical-align: middle;
    width: 12%;
    /* background: red; */
}

.table__head__wrapper .head__text__block span {
    display: block;
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 3px;
}

.table__head__wrapper .head__text__block p {
    display: block;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.syllable__tracker__data__table .table__head__wrapper,
.syllable__tracker__data__table .syllable__tracker__data__list__wrapper .row__item__block {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.syllable__tracker__data__table .table__head__wrapper .head__item__list {
    display: flex;
    align-items: center;
    width: 87%;
    justify-content: space-between;
}

.head__item__list .head__item__block {
    text-align: center;
    display: inline-block;
    vertical-align: top;
    /* width: 7.9%; */
    width: 7.5%;
}

.head__item__list .head__item__block+.head__item__block {
    /* padding-left: 25px; */
}

.head__item__list .head__item__block span {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: block;
    padding: 3px 0px 10px;
}

.head__item__block .label {
    border-radius: 3px;
    background-color: #eee8ff;
    color: #111610;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 5px 8px 8px 8px;
}

.checkbox__inline .checkbox {
    display: block;
    line-height: 0px;
    width: 20px;
    margin: 0px auto;
}

.checkbox__inline .blank__checkbox {
    width: 20px;
    border-radius: 5px;
    background-color: #dee2e7;
    height: 20px;
    display: block;
    margin: 0px auto;
}

.label__title__block span {
    display: block;
    color: #111610;
    font-family: 'Poppins';
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.row__item__block .label__title__block {
    display: inline-block;
    vertical-align: middle;
    width: 12%;
    /* background: brown; */
}

.row__item__block .checkbox__group__wrapper {
    display: flex;
    align-items: center;
    width: 87%;
    justify-content: space-between;
}

.checkbox__group__wrapper .checkbox__inline {
    display: inline-block;
    vertical-align: middle;
    width: 7.5%;
}

.checkbox__group__wrapper .checkbox__inline+.checkbox__inline {
    /* padding-left: 25px; */
}

.head__item__list .head__item__block.active .label {
    background-color: #725cff;
    color: #ffff;
}

.head__item__list .head__item__block .automate {
    background: #725cff;
    color: #ffff;
    border-radius: 3px;
    font-size: 18px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    padding: 5px 8px 8px 8px;
}

.head__item__list .head__item__block .manual {
    background: #36c27a;
    color: #ffff;
    border-radius: 3px;
    font-size: 18px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    padding: 5px 8px 8px 8px;
}


/* Preferences List */
.faq__info__block__wrapper .faq__block__item ul {
    padding: 0px 0px 0px 20px;
    list-style: disc;
}

.faq__info__block__wrapper .faq__block__item ul li p {
    padding-bottom: 5px;
}

.faq__info__block__wrapper .faq__block__item ul li p,
.faq__info__block__wrapper .faq__block__item ul li {
    color: #111610;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.indicator__block__wrap .indicator__option {
    display: inline-block;
    vertical-align: middle;
    /* padding-left: 15px; */
    margin-top: -15px;
}

.indicator__block__wrap .indicator__option img {
    width: 24px;
    display: inline-block;
    vertical-align: middle;
    margin-top: 15px;
}

.indicator__block__wrap .indicator__option span {
    display: inline-block;
    vertical-align: middle;
    padding-left: 15px;
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.mini__program__plan .indicator__block__wrap {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px 15px 10px 15px;
    /* background: red; */
}

img {
    max-width: 100%;
    height: auto;
    border: 0px;
}

.mini__program__plan .option__block__wrapper {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.option__block__wrapper .option__block__item h4.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    padding-bottom: 6px;
}

.option__block__wrapper .option__block__item .ans {
    padding: 14px 0px;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.option__block__wrapper .option__block__item+.option__block__item {
    padding-top: 25px;
    border-top: 1px solid #dee2e7;
}

.option__block__wrapper .option__block__item {
    /* padding-bottom: 20px; */
}

.mini__program__plan .note__block__wrapper {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.mini__program__plan .note__block__wrapper .inner__note__block {
    border-radius: 10px;
    background-color: #e8f2fc;
    padding: 15px;
}

.note__block__wrapper .head__group__wrap .btn__cover__block {
    display: inline-block;
    vertical-align: middle;
    width: 49.5%;
    text-align: right;
}

.note__block__wrapper .head__group__wrap span.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: inline-block;
    vertical-align: middle;
    width: 49.5%;
}

.note__block__wrapper .print__btn {
    display: inline-block;
    vertical-align: middle;
    border-radius: 6px;
    background-color: #725cff;
    padding: 8px 20px;
}

.note__block__wrapper .print__btn .btn__icon {
    display: inline-block;
    width: 20px;
    vertical-align: middle;
    line-height: 0px;
}

.note__block__wrapper .print__btn .btn__text {
    color: #fff;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: inline-block;
    vertical-align: middle;
}

.mini__program__plan .note__block__wrapper .text__block__wrapper {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.note__block__wrapper .text__block__wrapper p+p {
    padding-top: 10px;
}

/* Skills Preferences Match-Up */
.skills__preferences__box__wrapper {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.skills__preferences__box__wrapper .skill__preferences__row {

    border-bottom: 1px solid #dee2e7;
}

.skill__preferences__row .number__text {
    color: #111610;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: inline-block;
    width: 5%;
    /* background:red; */
}

.skill__preferences__row .text__block__wrapper {
    display: inline-block;
    vertical-align: top;
    width: 46.8%;
    /* background: red; */
}

.skill__preferences__row .text__block__wrapper span {
    display: block;
    padding-bottom: 6px;
    color: #111610;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    text-transform: capitalize;
}

.text__block__wrapper .text__wrapper {
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0px 0px 15px 0px;
}

/* Program Targets */
.target__keys__wrapper {
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px;
}

.target__keys__wrapper h4.section__title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 15px;
}

/* .target__keys__wrapper .target__key__list__wrapper {
            display: block;
            padding: 5px;
        } */

.taget__key__item__block h6.title {
    color: #111610;
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    padding: 10px 15px;
    margin-bottom: 20px;
}

.taget__key__item__block .number__block__wrapper .number__block {
    /* padding-top: 20px; */
}

.number__block__wrapper .number__block span {
    display: block;
    padding: 12px 15px;
    color: #3f444a;
    font-family: 'Poppins';
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-bottom: 1px solid #000000;
}

.indicator__block__wrap .indicator__option.padding__left {
    padding-left: 25px;
}

.ml10 {
    margin-left: 10px !important;
}

.group__row__block.mt20 {
    margin-top: 20px;
}

.group__row__block.mt-25 {
    margin-top: -25px;
}

.syllable__tracker__data__list__wrapper .pb__10px {
    padding-bottom: 15px;
}

/* Page break and top space for new page */
.page-break {
    page-break-before: always;
    display: block;
    height: 0;
}

.taget__key__item__block .number__block__wrapper {
    border-radius: 20px;
    background-color: #f6f2fd;
}


.number__block__wrapper .number__block:last-child span {
    border-bottom: 0px;
}

.taget__key__item__block .number__block__wrapper+.number__block__wrapper {
    margin-top: 12px;
}

.check__info {
    font-weight: normal;
    font-size: 13px;
}
</style>